import { render, staticRenderFns } from "./DialogNovoPapel.vue?vue&type=template&id=787a560c"
import script from "./DialogNovoPapel.vue?vue&type=script&lang=js"
export * from "./DialogNovoPapel.vue?vue&type=script&lang=js"
import style0 from "./DialogNovoPapel.vue?vue&type=style&index=0&id=787a560c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports